import u from 'umbrellajs/umbrella.esm.js';

export function initProgressBars() {

  document.addEventListener('DOMContentLoaded', () => {
    initProgressBars();
  });

  function initProgressBars(context = document) {
    const progressBars = u(context).find('[data-progress]');
    
    if (progressBars.length === 0) return; // Nothing to do

    progressBars.each(el => {
      const current = Number(el.dataset.current ?? 0);
      const min = Number(el.dataset.min ?? 0);
      const max = Number(el.dataset.max ?? 100);

      // Avoid division by zero
      const percent = max !== min ? Math.round(((current - min) / (max - min)) * 100) : 0;

      // Update progress-label if it exists
      const label = el.querySelector('[data-progress-label]');
      if (label) label.textContent = `${percent}%`;

      // Update progress-bar-label if it exists
      const label_text = el.querySelector('[data-progress-bar-label]');
      if (label_text) label_text.textContent = `${percent}%`;

      // Update fill if it exists
      const fill = el.querySelector('[data-progress-fill]');
      if (fill) fill.style.width = `${percent}%`;

      // Update ARIA attributes if bar exists
      const bar = el.querySelector('[data-progress-bar]');
      if (bar) {
        bar.setAttribute('aria-valuenow', current);
        bar.setAttribute('aria-valuemin', min);
        bar.setAttribute('aria-valuemax', max);
      }
    });
  }

}